import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { withRouter } from 'react-router-dom'
import Alerta from './Alerta'

import iconePesquisa from '../icones/fa-solid_search.png'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Creators as ConteudoHomeActions } from '../modulos/store/conteudo'
import { Creators as BuscarPesquisaActions } from '~/modulos/basico/store/buscarPesquisa'

const decodeHtml = html => {
    var txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
}

class Pesquisar extends React.Component {
    constructor(props) {
        super(props)
        this.state = { texto: '', msg: false, pesquisaMobileAberta: false }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)
        library.add(faSearch)
        this.searchBarOn = false
    }

    handleClose() {
        this.setState({ msg: false })
    }

    handleClick(evt) {
        if (this.state.texto.length >= 3) {
            this.props.buscaBuscarPesquisa(this.state.texto)
            this.state.statePesquisaMobile = false

            this.setState({ msg: false })
            if (evt) {
                evt.preventDefault()
            }
            let progs = this.props.programas.filter(e => {
                let hit = e.marca.toUpperCase().includes(this.state.texto.toUpperCase())
                if (hit) {
                    let index = e.marca.toUpperCase().indexOf(this.state.texto.toUpperCase())
                    e.result = (
                        <span>
                            {e.marca.substring(0, index)}
                            <b>{e.marca.substring(index, index + this.state.texto.length)}</b>
                            {e.marca.substring(index + this.state.texto.length, e.marca.length)}
                        </span>
                    )
                }
                return hit
            })

            // Busca no conteúdo do HOME
            let conteudo = `${this.props?.conteudo?.conteudo?.descricao || ''}`
            const offset = 50

            if (conteudo?.length) {
                var regex = /(<([^>]+)>)/gi
                conteudo = decodeHtml(conteudo.replace(regex, ''))
                if (conteudo.toUpperCase().includes(this.state.texto.toUpperCase())) {
                    let index = conteudo.toUpperCase().indexOf(this.state.texto.toUpperCase())
                    let match = (
                        <span>
                            ...{conteudo.substring(index - offset, index)}
                            <b>{conteudo.substring(index, index + this.state.texto.length)}</b>
                            {conteudo.substring(index + this.state.texto.length, index + this.state.texto.length + offset)}
                            ...
                        </span>
                    )
                    progs.push({ path: '/', result: match })
                }
            }

            if (!progs.length) {
                let semResultado = <span>A pesquisa não teve resultado com os critérios informados</span>
                progs.push({ path: '', result: semResultado })
            }

            this.props.setResult(progs)
            this.props.history.push('/resultadoPesquisa')
        } else {
            this.setState({ msg: true })
        }
    }

    handleChange(e) {
        this.setState({ texto: e.target.value })
    }

    handleMobilePesquisa(evt) {
        if (this.state.statePesquisaMobile === true && this.state.texto.length !== 0) {
            this.handleClick(evt)
        } else {
            this.togglePesquisa()
        }
    }

    togglePesquisa(val = !this.state.statePesquisaMobile) {
        this.setState({
            statePesquisaMobile: val,
        })
        if (this.state.statePesquisaMobile === true) {
            this.myInp.blur()
        } else {
            this.myInp.focus()
        }
    }

    render() {
        return (
            <div id="componentePesquisa" className="pesquisa">
                <input
                    id="campoPesquisar"
                    placeholder="Pesquise..."
                    className="entradaPesquisar"
                    type="text"
                    value={this.state.texto}
                    onChange={this.handleChange}
                    onKeyPress={e => {
                        if (e.key === 'Enter') {
                            this.handleClick(e)
                        }
                    }}
                />
                <div className="botaoPesquisar" type="submit" value="Pesquisar" onClick={e => this.handleClick(e)}>
                    <img className="iconeLupa" src={iconePesquisa} alt="lupa" />
                </div>
                <div className={this.state.statePesquisaMobile ? 'pesquisaInputMobile inputAberto' : 'pesquisaInputMobile inputFechado'}>
                    <input
                        id="campoPesquisarMobile"
                        placeholder="Pesquise..."
                        className="entradaPesquisarMobile"
                        type="text"
                        value={this.state.texto}
                        onChange={this.handleChange}
                        onKeyPress={e => {
                            if (e.key === 'Enter') {
                                this.handleClick(e)
                            }
                        }}
                        ref={ip => (this.myInp = ip)}
                    />
                </div>
                <FontAwesomeIcon onClick={e => this.handleMobilePesquisa(e)} className="iconePesquisaMobile" icon={faSearch} title="Pesquisa" size="2x" />
                <Alerta
                    isOpen={this.state.msg}
                    onClose={this.onClose}
                    titulo="Critérios de pesquisa"
                    mensagem="É necessário informar no mínimo 3 caracteres para pesquisar."
                    target="componentePesquisa"
                    placement="bottom"
                />
            </div>
        )
    }
}

const mapStoreToProps = store => ({
    conteudo: store.sistema.conteudoHome,
})

const mapDispatchToProps = dispatch => bindActionCreators({ ...ConteudoHomeActions, ...BuscarPesquisaActions }, dispatch)

export default withRouter(connect(mapStoreToProps, mapDispatchToProps)(Pesquisar))
